export default __webpack_public_path__ + "static/media/Vambraces of Baleful Blood.7edcab92.jpg";